module.exports = __webpack_public_path__ + "assets/nextcloud.56dbb366.svg";